// extracted by mini-css-extract-plugin
export default {"DetailPanel":"detailPanel_DetailPanel__Uu8KX","DetailPanel__body":"detailPanel_DetailPanel__body__xLPB+"};